import React, { PureComponent } from 'react';
import { Modal } from 'semantic-ui-react';
import _ from 'lodash';

class ModelComments extends PureComponent {
    render() {
        const { onClose, CommentList } = this.props;
        return (
            <Modal open='true' className="tiny errormodalbox">

                <Modal.Header>VOTE COMMENT/STATEMENT FOR ITEM NO. {CommentList && _.get(CommentList, 'BallotItemNumber') && CommentList.BallotItemNumber}<i onClick={onClose} data-testid="btnModalClose" className="close" title="close">&#x2716;</i></Modal.Header>
                <Modal.Content scrolling>
                    <Modal.Description>
                        {CommentList && _.get(CommentList, 'BallotItemNumber') && _.get(CommentList, 'BallotVoteComments') && CommentList.BallotVoteComments.length > 0 &&
                            CommentList.BallotVoteComments.map((item, index) => <div><p className="uppercase mb10"><strong>{item.Section}</strong></p>
                                <p className="mb10"><div dangerouslySetInnerHTML={{ __html: item.Comments }} ></div></p></div>)
                        }
                    </Modal.Description>
                </Modal.Content>
            </Modal >

        )
    }
}
export default ModelComments

